export default "__VITE_ASSET__CBGir9Fc__"